export default __webpack_public_path__ + "static/media/about-image.8178eb0d.png";